import type { Layout, RibbonScalingTransformation } from "owa-acui";
import type { ClientItemId } from "owa-client-ids";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import type { MailRibbonGroup } from "owa-mail-ribbon-store-shared-types";
import { getReadRibbonId } from "owa-mail-ribbon-utils/lib/getReadRibbonId";
import { getCustomizedLayoutForControlIds, isControlStacked, } from "owa-mail-ribbon-utils/lib/mlrCustomizationUtils";
import { type MailRibbonControlId } from "owa-ribbon-ids/lib/mailRibbonId";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";

export function getInitialQuickStepsScalingTransformation(group: MailRibbonGroup, itemId: ClientItemId | undefined): RibbonScalingTransformation | undefined {
    const initialLayout = getCustomizedLayoutForControlIds(group.controlIds, itemId)?.[0];
    return getQuickStepsScalingTransformation(initialLayout, itemId);
}

export function getQuickStepsScalingTransformation(layout: Layout | undefined, itemId: ClientItemId | undefined): RibbonScalingTransformation | undefined {
    if (!isGlobalFeatureEnabled("mon-ribbon-mlr-customization") || isWin32StylingEnabled()) {
        return undefined;
    }
    
    const quickStepsControlId = 550..toString();
    if (!isControlStacked(layout, quickStepsControlId)) {
        return undefined;
    }
    
    return {
        type: "GalleryToFlyout",
        controlId: getReadRibbonId(550, itemId).toString(),
    };
}
